import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { JwtModule } from '@auth0/angular-jwt';
import { getStoredToken } from 'app/state/auth.repository';
import { AppComponent } from './app.component';
import { environment } from 'environments/environment';
import { UnauthorizedModule } from './modules/unauthorized/unauthorized.module';
import { WhistleblowModule } from './modules/whistleblows/whistleblow.module';
import { TimelogsModule } from './modules/timelogs/timelogs.module';
import { ApvModule } from './modules/apv/apv.module';
import { MailModule } from './modules/mail/mail.module';
import { SessionInterceptor } from './modules/core/interceptors/session.interceptor';
import { DateInterceptor } from './modules/core/interceptors/date.interceptor';
import { ImageInterceptor } from './modules/core/interceptors/image.interceptor';
import { BaseUrlInterceptor } from './modules/core/interceptors/base-url.interceptor';
import { CoreModule } from './modules/core/core.module';
import { UnauthorizedRoutingModule } from './routing/unauthorized-routing.module';
import { ApvRoutingModule } from './routing/apv-routing.module';
import { WhistleblowRoutingModule } from './routing/whistleblow-routing.module';
import { TimelogsRoutingModule } from './routing/timelogs-routing.module';
import { MailRoutingModule } from './routing/mail-routing.module';

import { RouterModule } from '@angular/router';
import { PagenotfoundComponent } from './modules/core/pages/pagenotfound/pagenotfound.component';
import { RetryInterceptor } from './modules/core/interceptors/retry.interceptor';
import { EnvState } from './modules/shared/helpers/env-state';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoRootModule } from './transloco-root.module';
import { BLOB_STORAGE_TOKEN } from './shared/azure-blob/azureStorage';
import { BlobStorageService } from './shared/azure-blob//blob-storage.service';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { OutOfOfficeStatusModule } from './modules/out-of-office-status/out-of-office-status.module';
import { OutOfOfficeStatusRoutingModule } from './routing/out-of-office-status-routing.module';
import { AppRoutingModule } from './app-routing.module';
import { BaseModule } from './modules/base/base.module';
import { SharedModule } from './modules/shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgxEchartsModule } from 'ngx-echarts';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerInterceptor } from './modules/core/interceptors/spinner.interceptor';

const optionalModules = [];
const optionalProviders = [];

optionalModules.push(WhistleblowModule);
optionalModules.push(WhistleblowRoutingModule);

optionalModules.push(ApvModule);
optionalModules.push(ApvRoutingModule);

optionalModules.push(TimelogsModule);
optionalModules.push(TimelogsRoutingModule);

optionalModules.push(MailModule);
optionalModules.push(MailRoutingModule);

optionalModules.push(UnauthorizedModule);
optionalModules.push(UnauthorizedRoutingModule);

if (environment.features.offlineChanges) {
  optionalProviders.push({
    provide: HTTP_INTERCEPTORS,
    useClass: RetryInterceptor,
    multi: true,
  });
}
if (environment.features.outOfOfficeStatus) {
  optionalModules.push(OutOfOfficeStatusModule);
  optionalModules.push(OutOfOfficeStatusRoutingModule);
}
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import PrimeNgCustomPreset from './styles/primeng-custom-preset';
import { MiniProfilerInterceptor } from './shared/profiler-interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import localeEn from '@angular/common/locales/en';
import { CustomGptComponent } from './modules/chatGpt/custom-gpt.component';
import { SimpleChatComponent } from './modules/chatGpt/chat/simple-chat.component';
import { FormsModule } from '@angular/forms';

registerLocaleData(localeDa);
registerLocaleData(localeEn);
//initializeApp(environment.firebase);

@NgModule({
  declarations: [AppComponent, CustomGptComponent, SimpleChatComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    SharedModule,
    ToastModule,
    BrowserModule,
    CommonModule,
    // GooglePlaceModule,
    NoopAnimationsModule,
    TranslocoRootModule,
    MatDialogModule,
    CoreModule,
    BaseModule,
    AppRoutingModule,
    ProgressSpinnerModule,
    PopoverModule,
    RouterModule.forRoot([{ path: '**', component: PagenotfoundComponent }]),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyDOzV5scbP1PWye-hm6iiqyufG8p1-7Ew4',
    // }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => getStoredToken(),
        allowedDomains: [window.location.origin],
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
    }),
    ...optionalModules,
  ],
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: PrimeNgCustomPreset,
        options: { darkModeSelector: false },
      },
    }),
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DateInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ImageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseUrlInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    {
      provide: EnvState,
      useValue: environment,
    },
    BlobStorageService,
    {
      provide: BLOB_STORAGE_TOKEN,
      //@ts-ignore
      useValue: window['AzureStorage']?.Blob,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MiniProfilerInterceptor,
      multi: true,
    },
    ...optionalProviders,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
